import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { followupendpoints } from "../apis";

const { GET_FOLLOWUP_API,DELETE_FOLLOWUP_API,GET_FOLLOWUPLC_API,DELETE_FOLLOWUPLC_API } = followupendpoints;

// 1. Get followups
export function getFollowupsLC() {
  return async () => {
   // const toastId = toast.loading("Loading followups...");
     const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await apiConnector("GET", GET_FOLLOWUPLC_API,
        null,        {
          Authorization: `Bearer ${token}`,
        }
      );

      // response.data is already the array from controller
    //  console.log("followup data",response.data)
     // toast.success("Followups loaded");
      return response.data;
      
    } catch (error) {
    //  console.error("GET FOLLOWUPS ERROR:", error);
     // toast.error("Failed to load followups");
      return [];
    } finally {
     // toast.dismiss(toastId);
    }
  };
}

// 2. Delete followup
export function deleteFollowupLC(id) {
  return async () => {
   // const toastId = toast.loading("Deleting followup...");
    try {
      const response = await apiConnector("DELETE", `${DELETE_FOLLOWUPLC_API}/${id}`);

      //toast.success("Followup deleted successfully");
      return response.data; 
    } catch (error) {
    //  console.error("DELETE FOLLOWUP ERROR:", error);
      //toast.error("Failed to delete followup");
      return null;
    } finally {
    //  toast.dismiss(toastId);
    }
  };
}


// 1. Get followups
export function getFollowups() {
  return async () => {
   // const toastId = toast.loading("Loading followups...");
     const token = JSON.parse(localStorage.getItem("token"));
    try {
      const response = await apiConnector("GET", GET_FOLLOWUP_API,
        null,        {
          Authorization: `Bearer ${token}`,
        }
      );

      // response.data is already the array from controller
    //  console.log("followup data",response.data)
    //  toast.success("Followups loaded");
      return response.data;
      
    } catch (error) {
     // console.error("GET FOLLOWUPS ERROR:", error);
    //  toast.error("Failed to load followups");
      return [];
    } finally {
     // toast.dismiss(toastId);
    }
  };
}

// 2. Delete followup
export function deleteFollowup(id) {
  return async () => {
    const toastId = toast.loading("Deleting followup...");
    try {
      const response = await apiConnector("DELETE", `${DELETE_FOLLOWUP_API}/${id}`);

    //  toast.success("Followup deleted successfully");
      return response.data; 
    } catch (error) {
      console.error("DELETE FOLLOWUP ERROR:", error);
     // toast.error("Failed to delete followup");
      return null;
    } finally {
      toast.dismiss(toastId);
    }
  };
}
